import { useFetchPcrProcessLogsApi } from 'api/pcr_process_log'
import { pcrProcessLogColumnInfoList, PcrProcessLogTableData } from 'components/pcr_process_log/pcr_process_log_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import { ExTable, ModalButton, TableBody, TableHead } from 'components/shared/widget'
import { PcrProcessLog, PcrProcessLogSearchForm } from 'entities/pcr_process_log'
import { Badge, Button } from 'react-bootstrap'
import { useForm } from 'utils/hooks'

type ProcessLogsModalProps = {
    pcrProcessLogs?: PcrProcessLog[]
    pcrRunId?: string
    smallButton?: boolean
    onClickShowAll?: () => void
}

export const ProcessLogsModal = ({ pcrProcessLogs, pcrRunId, smallButton, onClickShowAll }: ProcessLogsModalProps) => {
    const pcrProcessLogDisplaySetting = useDisplaySetting(pcrProcessLogColumnInfoList(), 'PcrProcessLog')
    const searchForm = useForm<PcrProcessLogSearchForm>({ serializer: 'pure' })
    const api = useFetchPcrProcessLogsApi(searchForm)

    return (
        <ModalButton
            modalProps={{ size: 'xl' }}
            openButton={smallButton ? <Badge bg="info">結果ログ表示</Badge> : <Button variant="info">結果ログ表示</Button>}
            submitButton={
                <>
                    {onClickShowAll && (
                        <Button variant="info" onClick={onClickShowAll}>
                            全結果ログを表示
                        </Button>
                    )}
                </>
            }
            modalHeader={<div>{`結果ログ : ${pcrRunId}`}</div>}
            modalBody={
                <div style={{ overflow: 'scroll' }}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <tr>
                                <TableHeads displaySetting={pcrProcessLogDisplaySetting} />
                            </tr>
                        </TableHead>
                        <TableBody columnLength={pcrProcessLogDisplaySetting.getColumnLength() + 2}>
                            {(pcrProcessLogs ?? api.response.results)?.map((pcrProcessLog: PcrProcessLog) => {
                                return (
                                    <tr key={pcrProcessLog.id} style={{ backgroundColor: pcrProcessLog.result ? '#0801' : '#8001' }}>
                                        <PcrProcessLogTableData pcrProcessLog={pcrProcessLog} displaySetting={pcrProcessLogDisplaySetting} />
                                    </tr>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                </div>
            }
            handleOpen={() => {
                if (!pcrProcessLogs) {
                    searchForm.updateObject('pcrRunRunId', pcrRunId)
                }
            }}
        />
    )
}
